export enum ConnectionType {
	Standard,
	Lag,
	Manual,
	Association,
	Multi
}
